import React, { useState, useEffect } from "react";
import axios from "axios";
import profile from "../../Assets/employer_logo.png";

const TeammateModal = ({ candidate, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-center">
            <h4>{candidate.name}</h4>
            <p className="text-muted">{candidate.title}</p>
            {candidate.department && candidate.department !== 'NA' && (
              <p>Department: {candidate.department}</p>
            )}
            <p>{candidate.description || 'No additional description available.'}</p>
            <div className="team-social d-flex justify-content-center">
              {candidate.linkedin && (
                <a 
                  href={candidate.linkedin} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="mx-2"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              )}
              {candidate.twitter && (
                <a 
                  href={candidate.twitter} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="mx-2"
                >
                  <i className="fab fa-twitter"></i>
                </a>
              )}
              {candidate.portfolio && (
                <a 
                  href={candidate.portfolio} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="mx-2"
                >
                  <i className="fas fa-user-tie"></i>
                </a>
              )}
            </div>
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button 
              type="button" 
              className="btn btn-danger" 
              onClick={onClose}
              style={{ backgroundColor: 'red' }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CandidateItem = ({ candidate, onViewDetails }) => {
  const [imgSrc, setImgSrc] = useState(candidate.img ? `${process.env.REACT_APP_API_URL}${candidate.img}` : profile);

  const handleError = () => {
    setImgSrc(profile);
  };

  return (
    <div className="col-md-6 col-lg-3">
      <div className="team-item">
        <div className="team-img">
          <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high" src={imgSrc} alt={candidate.name} onError={handleError} />
        </div>
        <div className="team-content">
          <div className="team-bio">
          <h5>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                onViewDetails(candidate);
              }}>
                {candidate.name}
              </a>
            </h5>
            <span>{candidate.title}</span>
          </div>
          <ul className="team-social">
            {candidate.linkedin && (
              <li>
                <a href={candidate.linkedin} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
            )}
            {candidate.twitter && (
              <li>
                <a href={candidate.twitter} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
            )}
            {candidate.portfolio && (
              <li>
                <a href={candidate.portfolio} target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-user-tie"></i>
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

const OurTeam = () => {
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
   
  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}ourteam/allourteam`
        );
        const candidatesData = response.data.map((candidate) => ({
          id: candidate.id,
          name: candidate.name,
          title: candidate.designation,
          img: candidate.image || profile,
          linkedin: candidate.linkedin,
          portfolio: candidate.portfolio,
          twitter: candidate.twitter,
          department: candidate.department,
          description: candidate.description
        }));
        setCandidates(candidatesData);
      } catch (error) {
        console.error("Error fetching candidates:", error);
      }
    };

    fetchCandidates();
  }, []);

  const handleViewDetails = (candidate) => {
    setSelectedCandidate(candidate);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCandidate(null);
  };

  return (
    <div className="team-area py-120">
      <div className="container">
        <div className="row">
          <div
           className="col-lg-6 mx-auto text-center wow fadeInDown"
              data-wow-duration="1s"
              data-wow-delay=".25s"
            >
            <div className="site-heading">
              <span className="site-title-tagline">Our Team</span>
              <h2 className="site-title">Meet With Our Experts</h2>
              <p>We Help Companies And Candidates Find The Right Fit</p>
            </div>
          </div>  
        </div>
        <div className="row">
          {candidates.map((candidate) => (
            <CandidateItem key={candidate.id} candidate={candidate} onViewDetails={handleViewDetails} />
          ))}
        </div>
      </div>
      {selectedCandidate && (
        <TeammateModal
          candidate={selectedCandidate}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default OurTeam;
